/** @format */

import { api, encodeFileName } from 'utility';
import {
  getBusinessRequestUrl,
  getEDBusinessRequestUrl,
  getCRDUploadedDocsListUrl,
  getDocumentTypesUrl,
  getHasheFile,
  getFileUrl,
} from 'URLs';
// new procedure
export function getRequests(params) {
  return api.get(getBusinessRequestUrl(), { params }).then((res) => res.data);
}
export function getHashe(data) {
  return api.post(getHasheFile(), data).then((res) => res.data);
}
export function postRequest(data) {
  return api.post(getBusinessRequestUrl(), data).then((res) => res.data);
}

export function putRequest(reqId, data) {
  return api.put(getEDBusinessRequestUrl(reqId), data).then((res) => res.data);
}

export async function cancelRequest(reqId) {
  return api.delete(getEDBusinessRequestUrl(reqId));
}

export async function uploadDocService(data, name, type) {
  return api.post(getCRDUploadedDocsListUrl(), data, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'File-Type': type,
      'file-name': encodeFileName(name),
    },
  });
}

// is not used, old services
export function getDocumentsService() {
  return api.get(getCRDUploadedDocsListUrl()).then((res) => res.data);
}

export function getDocumentTypes() {
  return api.get(getDocumentTypesUrl()).then((res) => res.data);
}

export async function deleteDocService(data) {
  return api.delete(getCRDUploadedDocsListUrl(), { data });
}
export function getFile(hashCode) {
  return api.get(getFileUrl() + `/${hashCode}`, { responseType: 'blob' }).then((res) => res);
}

export default {
  uploadDocService,
  getRequests,
  postRequest,
  putRequest,
  cancelRequest,
  getHashe,
  getDocumentsService,
  getDocumentTypes,
  deleteDocService,
  getFile,
};
